import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import sanityClient from "../client.js";
import imageUrlBuilder from "@sanity/image-url";
import BlockContent from "@sanity/block-content-to-react";

const builder = imageUrlBuilder(sanityClient);
function urlFor(source) {
  return builder.image(source);
}

export default function SinglePost() {
  const [singlePost, setSinglePost] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    sanityClient
      .fetch(
        `*[slug.current == "${slug}"]{
        title,
        _id,
        slug,
        mainImage{
            asset->{
                _id,
                url
            }
        },
        body,
        "name": author->name,
        "authorImage": author->image
    }`
      )
      .then((data) => setSinglePost(data[0]))
      .catch(console.error);
  }, [slug]);

  // If there is no single post returned (something goes wrong)
  if (!singlePost) {
    return (
      <div className="flex justify-center p-40 loading-text">Loading...</div>
    );
  }

  return (
    <main>
      <section>
        <div className="title-container">
          <h1 style={{ fontSize: 50, color: "#ffffff" }} className="title-text">
            {singlePost.title}
          </h1>
          <img
            src={urlFor(singlePost.authorImage).url()}
            alt={singlePost.name}
            className="w-9 h-9 rounded-full"
          />
          <p
            style={{ fontSize: 15, color: "#ffffff", paddingTop: 10 }}
            className="title-text"
          >
            {singlePost.name}
          </p>
        </div>

        <div className="content-container">
          <BlockContent
            blocks={singlePost.body}
            projectId="222wxajt"
            dataset="production"
          />
        </div>
      </section>
    </main>
  );
}
